export function getGrowthSummary(rows: { year: number; gesamt_pakete: number }[]) {
  if (!rows.length) return null;
  const first = rows.reduce((earliest, row) => row.year < earliest.year ? row : earliest);
  return {
    start: first.gesamt_pakete,
    highest: Math.max(...rows.map(row => row.gesamt_pakete)),
  };
}